import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { takeUntil } from "rxjs/operators";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { MultipleExportModel } from "projects/sepidz-web-framework/src/lib/models/multiple-export.model";
import { Invoice } from "../../order/model/invoice.model";
import { TaxPayerSystemModel } from "projects/sepidz-web-framework/src/lib/models/TaxPayerSystem.model";

@Component({
  selector: "ngx-TaxPayerSystem",
  templateUrl: "./TaxPayerSystem.component.html",
  styleUrls: ["./TaxPayerSystem.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxPayerSystemFormComponent extends BaseFormComponent<TaxPayerSystemModel> {
  DefaultValues: Dictionary = [];
  InvoiceItemColumns: form_control[] = [];
  multipleExportItems: MultipleExportModel[] = [];
  invoiceList: Invoice[];
  gridColumns: form_control[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "TaxPayer";
    this.label = this.translate("ClientApp.FrontOffice.TaxPayerSystem.TaxPayerSystem");
    super.ngOnInit();
    this.GetColumns();
  }

  setColumnAttribute() {
    super.setColumnAttribute();
    if (!this.orignalColumns.some((s) => s.name === "Addbtn")) {
      const btn = new form_control();
      btn.name = "Addbtn";
      btn.label = this.translate("ClientApp.FrontOffice.TaxPayerSystem.PerformOperation");
      btn.formVisible = true;
      btn.order = 6;
      btn.controlType = FormControlTypes.Button;
      this.orignalColumns.push(btn);
    }
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
  }

  SetInvoiceFactor() {
    this.model.StartDate = this.formGroup.controls["StartDate"].value;
    this.model.EndDate = this.formGroup.controls["EndDate"].value;
    this.httpCommonService
      .create("TaxPayer/GetInvoices", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          this.invoiceList = data.Data;
        },
        (err) => {
          console.log(err);
        }
      );
  }
  async GetColumns() {
    await this.httpCommonService
      .getControlsList("TaxPayer/GetInvoiceInfo", true)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.gridColumns = data as form_control[];
            this.gridColumns = this.gridColumns.sort((a, b) => a.order - b.order);
          }
        },
        (error) => console.log(error)
      );
  }
  submitChange(controlName: string) {
    if (controlName === "Addbtn") {
      this.SetInvoiceFactor();
    }
  }
}
